module.exports = __webpack_public_path__ + "platform/static/media/failed.34b93c79.svg";